import { NgModule } from '@angular/core';
import { StoreProvider } from './store.provider';

@NgModule({
	providers: [StoreProvider]
})
export class StoreModule {}
